<template>
    <div class="row">

        <div class="col-xl-12 col-xs-12" v-if="loadCsv">
          <div class="table-wrapper">
                <h3>Please map columns to Orbitly inputs</h3>
                <table>
                    <thead>
                        <tr>
                            <th v-for="(head, index) in header" v-bind:key="head">
                              <select name="" id="" @change="SelectHead(index, $event)">
                                <option :value="head">Map this column</option>
                                <option :value="field" v-for="field in fields" v-bind:key="field">
                                  {{field}}
                                </option>
                              </select>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(_data, index) in [header, ...csv_data]" v-bind:key="index" v-if="!headerCheckbox">
                            <td v-for="(lead, inx) in _data" v-bind:key="inx">
                              {{lead}}
                            </td>
                        </tr>
                        <tr v-for="(_data, index) in csv_data" v-bind:key="index" v-if="headerCheckbox">
                            <td v-for="(lead, inx) in _data" v-bind:key="inx">
                              {{lead}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="m-t-20">
              <input type="checkbox" :checked="headerCheckbox" v-model="headerCheckbox"> Ignore first row
            </div>
            <div class="m-t-20">
              <button tag="button" class="btn btn-small" @click="setData({file:false, state:'default', credits:0, text:text})">Upload another file </button>
              <button tag="button" class="btn btn-small content-right" @click="nextStep">Next -></button>
            </div>
        </div>

        <div class="col-xl-12 col-xs-12" v-if="!loadCsv">
            <div v-bind:class="[state == 'default' ? 'dotted hover' : 'dotted']">
                <div class="dotted-content-load" v-if="state === 'processing'">
                    <i class="fas fa-sync fa-spin fa-2x"></i>
                    <h4> {{loading_text}} </h4>
                    <span>{{load}}%</span>
                </div>
                <div class="dotted-content" v-if="state === 'default'">
                    <i class="fas fa-arrow-circle-up fa-3x"></i>
                    <h3> Drag and drop to upload </h3>
                    or <label>browse</label> to choose a file
                    <input type="file" ref="file" @change="selectFile" accept=".csv,text/csv">
                </div>
                <div class="dotted-content-load" v-if="state === 'credits'">
                    <img src="@/assets/info-icon.svg"  class="icon" width="40" height="40"/>
                    <h3> Orbitly found {{credits}} lead records to enrich </h3>
                    <p> But you do not have enough credits, please buy more credits </p>
                    <div>
                      <button @click="showCreditmodal" class="btn btn-small bold">Buy more credits</button>
                      <p class="browse" @click="setData({file:false, state:'default', credits:0, text:text})"> upload another file </p>
                    </div>
                </div>
                <div class="dotted-content-load" v-if="state === 'main'">
                    <i class="far fa-check-circle fa-3x"></i>
                    <h3> Orbitly found {{credits}} lead records to enrich </h3>
                    <p> you will have <span class="credit-text">{{ user_credits - credits }} credits</span> left after we enrich your leads </p>
                    <div class="checkboxes">
                      <p :title="title_orbitly"><strong>Optional:</strong> enrich lead record only if </p>
                      <div class="box-ul">
                        <ul>
                          <li><input v-model="email" type="checkbox"> email is available </li>
                          <li><input v-model="phone" type="checkbox"> phone is available </li>
                          <li><input v-model="profile" type="checkbox"> social profile is available </li>
                        </ul>
                      </div>
                    </div>
                    <div class="enrich-btn">
                      <button @click="sendFile" class="btn btn-small bold">Enrich leads</button>
                      <p class="browse" @click="setData({file:false, state:'default', credits:0, text:text})"> upload another file </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-12 col-xs-12">
         <a href="https://www.orbitly.io/how-to-format-your-csv" target="_blank" class="csv-format"> see: How to format your CSV ? </a>
        </div>
    </div>
</template>

<script>

import { mapMutations } from 'vuex'
import Papa from 'papaparse'

export default {
  name: 'drag_and_drop',
  mounted () {
    this.messageStorage.destroyAll()
    this.pollFunction()
  },
  data () {
    return {
      messageStorage: this.flash(),
      title_orbitly: 'Enabling this option allows you to require email, phone, or both data fields. \n \n Requiring email or phone ensures you are charged only for records that can be enriched with these data fields. \n \n If email or phone is unavailable for a record, Orbitly will skip the contact.',
      load: 0,
      text: 'Verifying uploaded leads',
      email: false,
      phone: false,
      headerCheckbox: true,
      profile: false,
      request_type: 'default',
      header: [],
      originalHeader: [],
      copyHeader: [],
      csv_data: [],
      loadCsv: false,
      headerInput: false,
      _file: false,
      step: 1,
      headObject: {},
      headModel: '',
      fields: [
        'name',
        'first name',
        'middle name',
        'last name',
        'email',
        'phone',
        'company',
        'school',
        'location',
        'region',
        'country',
        'linkedin_url',
        'facebook_url',
        'twitter_url',
        'angellist_url',
        'github_url',
        'medium_url',
        'gravatar_url',
        'klout_url',
        'aboutme_url'
      ]
    }
  },
  methods: {
    ...mapMutations([
      'user/setAuthUser',
      'uploadedLeadList/modalState',
      'uploadedLeadList/changeCredits',
      'uploadedLeadList/setFileData',
      'uploadedLeadList/setPending',
      'uploadedLeadList/changeUpdateInfo',
      'user/setCredits',
      'uploadedLeadList/setLeads'
    ]),
    changeHeader (val) {
      this.headerCheckbox = val
    },
    changeUpdateInfo (val) {
      this['uploadedLeadList/changeUpdateInfo'](val)
    },
    SelectHead (index, e) {
      let selectedHead = this.header
      selectedHead[index] = e.target.value
      this.header = selectedHead
    },
    pollFunction: function () {
      var time = setInterval(function () {
        if (!this.pending) {
          clearInterval(time)
          this.setData({ file: false, state: 'default', credits: 0, text: this.text })
        } else {
          this.pollLeads()
        }
      }.bind(this), 5000)
    },
    pollLeads: function () {
      this.$http.get('/api/leads/pending_leads/' + this.pending).then((res) => {
        if (res.status === 200) {
          this['uploadedLeadList/setLeads'](res.data.leads)
          this['user/setCredits'](res.data.user_credits)
          this['uploadedLeadList/setPending'](false)
          this.load = res.data.percentage
          this.$notify({
            group: 'foo',
            title: 'File upload',
            type: 'success',
            text: 'Your file has been processed',
            duration: 10000
          })
          this.setData({ file: false, state: 'default', credits: 0, text: this.text })
          this.request_type = 'default'
        } else if (res.status === 202) {
          this.load = res.data.percentage
        }
      }).catch((err) => {
        this.setData({ file: false, state: 'default', credits: 0, text: this.text })
        console.log(err)
      })
    },
    showCreditmodal: function () {
      if (!this.user_card) {
        // this.$router.push({ name: 'billing' })
        this.$emit('showCreditmodal')
        this['uploadedLeadList/modalState'](true)
        this.changeUpdateInfo(false)
        return
      }
      this.$emit('showCreditmodal')
      this['uploadedLeadList/modalState'](true)
      this.changeUpdateInfo(true)
    },
    setData: function (data) {
      this.step = false
      this._file = false
      this.loadCsv = false
      this['uploadedLeadList/setFileData'](data)
    },
    showMessage (text, title) {
      this.$notify({
        group: 'foo',
        title: title,
        type: 'error',
        text: text,
        duration: 10000
      })
      this.setData({ file: false, state: 'default', credits: 0, text: this.text })
    },
    sendFile: function () {
      this.request_type = 'main'
      var formData = this.file
      formData.set('phone', this.phone)
      formData.set('email', this.email)
      formData.set('profile', this.profile)
      formData.set('type', this.request_type)
      this.selectFileServer(formData)
    },
    nextStep: function () {
      this.step = 2
      this.selectFile()
    },
    selectFile: function () {
      if (!this._file) {
        this._file = this.$refs.file.files[0]
      }
      if (this.step === 2) {
        this.loadCsv = false
        var formData = new FormData()
        formData.append('file', this._file)
        formData.append('phone', this.phone)
        formData.append('email', this.email)
        formData.append('profile', this.profile)
        formData.append('type', this.request_type)
        formData.append('columns', JSON.stringify(this.header))
        formData.append('original_columns', JSON.stringify(this.originalHeader))
        this.selectFileServer(formData)
      } else {
        let that = this
        Papa.parse(this._file, {
          worker: true, // Don't bog down the main thread if its a big file
          complete: function (results) {
            if (results.data.length) {
              let head = []
              if (!that.loadCsv) {
                that.header = results.data[0]
                that.originalHeader = [...results.data[0]]
                console.log(that.originalHeader)
                for (let index = 0; index < that.header.length; index++) {
                  that.headObject[index] = that.header[index]
                  head.push('')
                }
                that.csv_data = results.data.splice(1, 5)
              }
              that.copyHeader = head
              that.loadCsv = true
            }
          }
        })
      }
    },
    selectFileServer: function (formData) {
      this.setData({ file: formData, state: 'processing', credits: 0, text: this.text })
      var that = this
      this.$http.post('/api/leads/upload_leads', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        progress (e) {
          if (e.lengthComputable) {
            let _progress = Math.round(e.loaded / e.total * 100)
            that.load = _progress
          }
        }
      }).then((res) => {
        if (res.status === 200) {
          this.setData({ file: false, state: 'processing', credits: 0, text: res.data.message })
          this['uploadedLeadList/setPending'](res.data.pending_leads)
          this['user/setAuthUser'](res.data)
          this.load = 0
          this.pollFunction()
        } else if (res.status === 202) {
          this.setData({ file: formData, state: 'main', credits: res.data.credits, text: this.text })
          let creditsYouNeed = this.credits - this.user_credits
          this['uploadedLeadList/changeCredits']({ 'total': creditsYouNeed, 'value': false })
        }
      }).catch((err) => {
        if (err.status === 402) {
          this.setData({ file: formData, state: 'credits', credits: err.body.credits, text: this.text })
          let creditsYouNeed = this.credits - this.user_credits
          this['uploadedLeadList/changeCredits']({ 'total': creditsYouNeed, 'value': false })
        } else if (err.status === 400) {
          this.showMessage('Make sure you upload a CSV file', 'Invalid file')
        } else if (err.status === 510) {
          this.showMessage('You need more columns in your file </br> <a href="https://www.orbitly.io/how-to-format-your-csv" target="_blank"> How to format your CSV </a>', 'Invalid format')
        }
      })
    }
  },
  computed: {
    user_credits: function () {
      return this.$store.state.user.data.credits
    },
    user_card: function () {
      return this.$store.state.user.data.stripe_obj
    },
    credits: function () {
      return this.$store.state.uploadedLeadList.fileCredits
    },
    state: function () {
      return this.$store.state.uploadedLeadList.fileState
    },
    file: function () {
      return this.$store.state.uploadedLeadList.file
    },
    loading_text: function () {
      return this.$store.state.uploadedLeadList.fileText
    },
    pending: function () {
      return this.$store.state.uploadedLeadList.id_pending
    }
  }
}
</script>

<style lang="scss" scoped>

    .btn-txt {
        height: 30px;
        span {
            display: inline-block;
            vertical-align: middle;
            margin-top: 5px
        }
    }

    .btn-txt:hover {
        background-color: $light-1
    }

    .inline-block {
        display: inline-block;
        margin-top: 10px;
        vertical-align: middle;
    }

    .left {
        float: left;
        margin-top: 20px
    }

    .right {
        float: right;
    }

    .table-wrapper {
        max-width: 100%;
        overflow: scroll;
    }

    table {
        position: relative;
        border: 1px solid #ddd;
        border-collapse: collapse;
    }

    td, th {
        white-space: nowrap;
        border: 1px solid #ddd;
        padding: 20px;
        text-align: left;
    }

    th {
        background-color: #eee;
        position: sticky;
        top: -1px;
        z-index: 2;
    }
</style>
